const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/global-survey-response.$surveyId.index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/global-survey-response/$surveyId/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});